<template>
  <div class="middle-bar animated fadeInLeftBig">
    <div class="mainDiv">
      <div class="b-line"></div>
      <div v-for="(item, i) in navList" :key="i">
        <div class="flex">
          <div class="bf" :class="i === active ? 'active' : ''"></div>
          <div
            class="item"
            :class="i === active ? 'active' : ''"
            @click="onChange(i)"
          >
            {{ item.name }}
          </div>
        </div>
        <template v-if="i === active">
          <div class="flex sub" v-for="(it2, i2) in item.children" :key="i2">
            <div class="bf" :class="it2.active === true ? 'active' : ''"></div>
            <div
              class="item"
              :class="it2.active === true ? 'active' : ''"
              @click="onChange2(i2)"
            >
              {{ it2.name }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { lchooseMixin } from "@/util/mixin/lchooseMixin";
export default {
  mixins: [lchooseMixin],
  data() {
    return {
      navList: [
        {
          name: "检疫开证点"
        },
        {
          name: "生猪屠宰开证"
        },
        {
          name: "生猪屠宰猪只"
        },
        {
          name: "生猪屠宰猪产品"
        },
        {
          name: "涉农企业",
          children: [
            {
              active: true,
              name: "龙头企业"
            },
            {
              active: false,
              name: "合作社"
            },
            {
              active: false,
              name: "家庭农场"
            },
            {
              active: false,
              name: "农资经营企业"
            },
            {
              active: false,
              name: "生产基地"
            }
          ]
        }
        // {
        //   name: "肉产品消费流向"
        // },
        // {
        //   name: "检疫开证情况"
        // }
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
@import '~styl/granary/choose'
</style>
